import React from "react"
import { css } from 'styled-components'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import BusinessIcon from '@material-ui/icons/Business'
import PersonIcon from '@material-ui/icons/Person'
import WarningIcon from '@material-ui/icons/Warning'
import Tooltip from '@material-ui/core/Tooltip'
import { FlexContainer, PercentageLabel } from "heliocor-ui"

import 'styled-components/macro'
import { AddItem } from "../../common"

const iconStyle = css`&&{cursor: pointer; font-size: 1rem; margin: .25rem 0.5rem 0 0;}`
const iconWarningStyle = ({ theme }) => css`&&{cursor: pointer; font-size: 1rem; margin: .25rem 0.5rem 0 0; color: ${theme.colors.mustard100}}`

const iconPicker = (type) => {
    switch (type) {
        case 'COMPANY':
            return <BusinessIcon css={iconStyle} />
        case 'PERSON':
            return <PersonIcon css={iconStyle} />
        default:
            return
    }
}

function getRelationTexts(values, translate) {
    let roleTT = [], role = []
    if (values.director) {
        roleTT.push(translate('director'))
        role.push(translate('director').charAt(0))
    }
    if (values.shareholder) {
        roleTT.push(translate('shareholder'))
        role.push(translate('shareholder').charAt(0))
    }
    if (values.ubo) {
        roleTT.push(translate('ubo'))
        role.push(translate('ubo').charAt(0))
    }
    if (values.authorizedSignatory) {
        roleTT.push(translate('authorizedSignatory'))
        role.push(translate('authorizedSignatory').charAt(0))
    }
    return <Tooltip title={roleTT.join(' & ')}><span>{role.join(' ')}</span></Tooltip>
}

export const STRUCTURE_COLUMNS = (translate, isMobile, errors) => [
    {
        key: 'type',
        width: '20%',
        render: values => <div style={{ paddingLeft: values.level * 18 }}>{iconPicker(values.type)}</div>
    }, {
        key: 'name',
        width: isMobile ? '25%' : '30%',
        render: values => values.surname && values.type === 'PERSON' ? `${values.name} ${values.surname}` : values.name
    }, {
        key: 'relation',
        width: '10%',
        render: values => getRelationTexts(values, translate)
    }, {
        key: isMobile ? '%' : 'ultimateOwnership',
        width: isMobile ? '2%' : '20%',
        render: (values) => isMobile
            ? <p>{values.ultimateOwnership || values.ownership}%</p>
            : <PercentageLabel percentage={(values.ultimateOwnership) || values.ownership || 0} />
    }, {
        key: '',
        width: '10%',
        render: (values, args) => (
            <FlexContainer justifyContent='end'>
                {values.minDocsNotReached &&
                    <Tooltip
                        title={translate('warning.uploadOwnerDocuments')}
                        placement='left'
                        disableFocusListener
                    >
                        <WarningIcon css={iconWarningStyle} />
                    </Tooltip>
                }
                {errors?.find(e => e.identifier === values.identifier) &&
                    <Tooltip
                        title={translate('warning.cpValidationErrors')}
                        placement='left'
                        disableFocusListener
                    >
                        <WarningIcon css={iconWarningStyle} />
                    </Tooltip>
                }
                <Edit data-cy="edit-structure-item" css={iconStyle} onClick={() => args.handleEdit(values, args.index)} />
                <Delete data-cy="delete-structure-item" css={iconStyle} onClick={() => args.handleDelete(values)} />
            </FlexContainer>
        )
    }
]

export const STRUCTURE_LOOKUP = (translate, isMobile) => [
    {
        key: 'name',
        width: '30%',
        render: (values) => values.surname ? `${values.name} ${values.surname}` : values.name
    }, {
        key: 'type',
        width: '10%',
        render: values => getRelationTexts(values, translate)
    }, {
        key: '',
        width: '12%',
        extraStyle: 'padding: 0',
        render: (values, args) => (
            <AddItem onClick={() => args.handleEdit({ ...values, parentId: 'parent'}, args.index, true)}
                data-cy="edit-structure-item"
                translate='addAsEntity'
                margin='0'
                marginTitle="0"
                showTitle={!isMobile}
            />
        )
    },
    {
        key: '',
        width: '5%',
        render: (values, args) => (
            <Delete
                data-cy="delete-structure-item"
                css={iconStyle}
                onClick={() => args.handleDelete(values)}
            />
        )
    },
]

export const STRUCTURE_COLUMNS_SUMMARY = (translate, isMobile) => [
    {
        key: 'type',
        width: '20%',
        render: values => <div style={{paddingLeft: values.level * 18}}>{iconPicker(values.type)}</div>
    }, {
        key: 'name',
        width: '30%',
        render: values => values.surname && values.type === 'PERSON' ? `${values.name} ${values.surname}` : values.name
    }, {
        key: 'relation',
        width: '10%',
        render: values => getRelationTexts(values, translate)

    },
    {
        key: isMobile ? '%' : 'ultimateOwnership',
        width: isMobile ? '5%' : '20%',
        render: (values) => isMobile
            ? <p>{values.ultimateOwnership}%</p>
            : <PercentageLabel percentage={values.ultimateOwnership} />
    }
]
